import { defineComponent as _defineComponent } from 'vue'
import useIcons from '@/composables/useIcons'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'Pagination',
  props: {
    totalPages: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    allowPageClick: {
      type: Boolean,
      default: true,
    },
    submitText: {
      type: String,
      default: '',
    },
  },
  emits: ['next', 'previous', 'submit', 'page'],
  setup(__props, { emit }) {

const props = __props;

  
  
  const { previousIcon, nextIcon } = useIcons()
  const onPreviousPage = () => {
    if (props.currentPage === 1) return
    emit('previous')
  }

  const onNextPage = () => {
    if (props.currentPage === props.totalPages) {
      if (props.submitText) emit('submit')
      return
    }
    emit('next')
  }

  const onPageClick = (page: number) => {
    if (props.allowPageClick) emit('page', page)
  }

return { __sfc: true,props, emit, previousIcon, nextIcon, onPreviousPage, onNextPage, onPageClick, useIcons }
}

})